import script from "./UReportsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./UReportsHeader.vue?vue&type=script&setup=true&lang=ts"

import "./UReportsHeader.vue?vue&type=style&index=0&id=06467e66&lang=css"

const __exports__ = script;

export default __exports__